import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = {
  key: 0,
  class: "text-muted fw-100"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "si si-question va-middle" }, null, -1 /* HOISTED */)
const _hoisted_4 = {
  key: 2,
  class: "push-5"
}
const _hoisted_5 = { class: "text-muted" }
const _hoisted_6 = {
  key: 3,
  class: "push-5-t has-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popover = _resolveComponent("Popover")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!!_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: _ctx.inputID()
        }, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1 /* TEXT */),
          (!_ctx.fieldIsRequired)
            ? (_openBlock(), _createElementBlock("em", _hoisted_2, "- Optional"))
            : _createCommentVNode("v-if", true)
        ], 8 /* PROPS */, _hoisted_1))
      : _createCommentVNode("v-if", true),
    (_ctx.helpTooltip && _ctx.helpTooltip.length)
      ? (_openBlock(), _createBlock(_component_Popover, {
          key: 1,
          content: _ctx.helpTooltip,
          placement: "right"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["content"]))
      : _createCommentVNode("v-if", true),
    (_ctx.helpText && _ctx.helpText.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("em", _hoisted_5, _toDisplayString(_ctx.helpText), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass({ 'has-error': _ctx.hasErrors })
    }, [
      _renderSlot(_ctx.$slots, "default", {
        id: _ctx.inputID()
      }),
      _createCommentVNode(" id slotProp used in parent context as input :id for accessibility ")
    ], 2 /* CLASS */),
    (_ctx.hasErrors)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (err, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "help-block animated fadeInDown push-5-t",
              key: idx
            }, _toDisplayString(err), 1 /* TEXT */))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}